export default "__VITE_ASSET__cl7Jcazp__"